import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

import { isChunkLoadErrorMessage } from './chunk-load-error.helper';

const RELOAD_TIMESTAMP_KEY = 'chunk-load-reload-at';
// If a reload happened within this window and the chunk still fails, stop
// reloading and report the error instead — avoids an infinite reload loop when
// the chunk is genuinely unreachable.
const RELOAD_DEBOUNCE_MS = 15000;

@Injectable()
class ChunkLoadErrorHandler implements ErrorHandler {
    private readonly sentryHandler = Sentry.createErrorHandler({ logErrors: true });

    public handleError(error: unknown): void {
        if (isChunkLoadErrorMessage(error) && this.shouldReload()) {
            window.location.reload();
            return;
        }

        this.sentryHandler.handleError(error);
    }

    private shouldReload(): boolean {
        const lastReload = Number(window.sessionStorage.getItem(RELOAD_TIMESTAMP_KEY));
        const now = Date.now();
        if (lastReload && now - lastReload < RELOAD_DEBOUNCE_MS) {
            return false;
        }

        window.sessionStorage.setItem(RELOAD_TIMESTAMP_KEY, String(now));
        return true;
    }
}

export default ChunkLoadErrorHandler;
